
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/calendar/jst/calendarApp';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div class=\"scheduler-wrapper\" style=\"display: none\">\n  <div class=\"appointment-list\">\n    <div class=\"list-wrapper\"></div>\n  </div>\n</div>\n<div class=\"agenda-wrapper\"></div>\n<div class=\"scheduler_navigator\"></div>\n<div class=\"calendar\"></div>\n";
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';

    brandableCss.loadStylesheetForJST({
      id: 'c8',
      bundle: 'jst/calendar/calendarApp'
    });
  ;
    export default templates[name];
  